import { defineComponent as _defineComponent } from 'vue'
import BaseChip from "@/components-UI/BaseChip.vue";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { RouteCellData } from "@/utils/CellsFactory";
import SvgCopy from "@/assets/icons/copy2.svg";
import { useCopyText } from "@/utils/copyText";

interface Props {
    data: RouteCellData;
    item: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteCell',
  props: {
    data: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
    data: RouteCellData;
    item: any;
}


const router = useRouter();

const resolveProp = <T>(prop: T | ((item: any) => T)): T =>
    typeof prop === "function" ? (prop as any)(props.item) : prop;

const text = computed(() => {
    if (typeof props.data.text === "function") {
        return props.data.text(props.item);
    } else if (typeof props.data.text === "string") {
        return props.item.hasOwnProperty(props.data.text)
            ? String(props.item[props.data.text] ?? "")
            : props.data.text;
    }
    return String(props.item[props.data.valueKey] ?? "");
});

const isChip = computed(() => {
    if (!text.value) return false;
    return resolveProp(props.data.isChip);
});

const tooltip = computed(() => {
    if (!props.data.tooltip) return "";
    return resolveProp(props.data.tooltip) ?? props.item[props.data.valueKey];
});

const icon = computed(() => resolveProp(props.data.icon));

const routeLink = computed(() => {
    const name = resolveProp(props.data.name);
    const query = resolveProp(props.data.query);
    let params = { id: props.item[props.data.valueKey] };

    if (props.data.customParams) {
        params = props.data.customParams(props.item);
    }

    // const params = { id: props.item[props.data.valueKey] };
    return router.resolve({ name, params, query }).href;
});

const getIndent = computed(() => {
    const indent = props.data.iconIndent ? `calc(100% + ${props.data.iconIndent}px)` : "100%";
    return { right: indent };
});

const copyValue = () => {
    useCopyText(text.value, 'Скопировано');
};

return { __sfc: true,props, router, resolveProp, text, isChip, tooltip, icon, routeLink, getIndent, copyValue, BaseChip, BaseTooltip, SvgCopy }
}

})